import Vue from 'vue'

let eventsBus = new Vue({ name: 'eventsBus' })

eventsBus.NEW_EVENT = 'newEvent'
eventsBus.DELETED_EVENT = 'deletedEvent'
eventsBus.UPDATED_EVENT = 'updatedEvent'
eventsBus.NEW_EVENTS = 'newEvents'

eventsBus.UPDATED_GROUP_COLOR = 'updatedGroupColor'

eventsBus.NEW_POLL = 'newPoll'
eventsBus.DELETED_POLL = 'deletedPoll'

eventsBus.NEW_MESSAGE = 'newMessage'

eventsBus.LANGUAGE_CHANGED = 'languageChanged'

eventsBus.SHOW_LOADING = 'showLoading'
eventsBus.HIDE_LOADING = 'hideLoading'

eventsBus.SHOW_KEYSHORTCUTS = 'show_keyshortcuts'

eventsBus.CLICK_ON_SIDEBAR = 'clickOnSideBar'

export default eventsBus



// WEBPACK FOOTER //
// ./src/components/shared/EventsBus.js